<!-- 
Presents a read-only label / value pair.

Designed to be used as a child of the OurDataContainer component.
-->
<template>
  <v-flex :class="`sm${labelWidth} offset-xs${offset}`" xs10>
    <p class="mb-1 grey--text text--darken-1">
      <span :id="uid">{{ label }}</span>
      <slot name="label" />
    </p>
    <p :class="`${typography} ${marginAdjustment} field`">
      <span v-if="!slotFilled" class="font-weight-regular">{{ empty }}</span>
      <slot/>
    </p>
    <slot name="footer"/>
  </v-flex>
</template>

<script>
import _ from "underscore";

export default {
  props: {
    label: {
      default: "",
      type: String
    },
    labelWidth: {
      default: 5,
      validator: prop => typeof prop === "number" || typeof prop === "string"
    },
    offset: {
      default: 1,
      validator: prop => typeof prop === "number" || typeof prop === "string"
    },
    typography: {
      type: String,
      default: "subheading font-weight-medium"
    },
    empty: {
      type: String,
      default: "Not specified"
    }
  },
  data() {
    return {
      slotFilled: false
    };
  },
  computed: {
    uid() {
      return this._uid;
    },
    marginAdjustment() {
      return this.hasFooterSlot ? " mb-0" : "";
    },
    hasFooterSlot() {
      return !!this.$slots["footer"];
    }
  },
  mounted() {
    this.updateSlotFilled();
  },
  updated() {
    this.updateSlotFilled();
  },
  methods: {
    updateSlotFilled() {
      this.slotFilled =
        _(this.$slots.default).filter(item => item && item.elm.textContent && item.elm.textContent.trim().length > 0)
          .length > 0;
    }
  }
};
</script>
